import { Component, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DistrictAdministrationService } from "../../services/districtadministration.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { DistrictAddHolidayComponent } from "./district-add-holiday/district-add-holiday.component";
import { CalendarHolidayInsertRequest } from "./shared/calendar-holiday-insert-request";
import * as moment from "moment";
import { DistrictImportHolidayComponent } from "./district-import-holiday/district-import-holiday.component";
import { CalendarHolidayImportRequest } from "./shared/calendar-holiday-import-request";

@Component({
	selector: "caass-district-calendar-holiday-view",
	templateUrl: "./district-calendar-holiday-view.component.html",
	styleUrls: ["./district-calendar-holiday-view.component.css"],
})
export class DistrictCalendarHolidayViewComponent implements OnInit {
	constructor(
		private districtService: DistrictAdministrationService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loadHolidays();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	subscription: any;

	SelectedHolidays: any = [];
	lstHoliday: any = [];

	//Filter lists
	lstIsOpenDesc: any = [];
	lstInFutureDesc: any = [];

	HolidayLoading: boolean = false;
	errorMessage: any = "";

	pagerows: any = 10;
	pagefirst: any = 0;

	cols: any = [
		{ field: "CalendarDateDesc" },
		{ field: "IsOpenDesc" },
		// { field: "SchoolCount" },
		// { field: "InFutureDesc" }
	];

	Processing: boolean = false;

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadHolidays() {
		this.HolidayLoading = true;

		// this.onRowUnselect(null);
		this.SelectedHolidays = [];

		var result = this.districtService.HolidaySelectList(-1);
		result.subscribe(
			(response) => {
				this.lstHoliday = response;

				this.lstIsOpenDesc = Array.from(new Set(this.lstHoliday.map((item: any) => item.IsOpenDesc))).sort();
				this.lstInFutureDesc = Array.from(new Set(this.lstHoliday.map((item: any) => item.InFutureDesc))).sort();

				this.HolidayLoading = false;
			},
			(error) => {
				this.HolidayLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadHolidays();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictAddHolidayComponent, {
			header: "Add Holiday",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHolidays();
			}
		});
	}

	//
	//	NEW, Remove Multiple
	//

	onRemove() {
		this.errorMessage = "";

		if (this.SelectedHolidays.length == 0) {
			this.errorMessage = "Select Holidays to Remove";
			return;
		}

		this.confirmationService.confirm({
			key: "districtholidayconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to remove " + this.SelectedHolidays.length + " holidays? Note: This will update all schools",
			header: "Confirm Remove Holiday",
			icon: "fa",
			accept: () => {
				this.onFinishRemove();
			},
		});
	}

	onFinishRemove() {
		this.Processing = true;

		var lstCalendarDates: string[] = [];
		var lstOpen: number[] = [];
		var lstSID: number[] = [];

		for (var z = 0; z < this.SelectedHolidays.length; z++) {
			var next = this.SelectedHolidays[z];

			lstCalendarDates = [...lstCalendarDates, moment(new Date(next.CalendarDate)).format("MM/DD/YYYY")];
			lstOpen = [...lstOpen, next.IsOpen == true ? 0 : 1];
		}

		var parms: CalendarHolidayImportRequest = {
			lstCalendarDates: lstCalendarDates,
			lstOpen: lstOpen,
			OverwriteExisting: 0,
			StartDate: moment(new Date()).format("MM/DD/YYYY"),
			EndDate: moment(new Date()).format("MM/DD/YYYY"),
			AllSchools: 1,
			lstSchools: lstSID,
		};

		var result = this.districtService.CalendarHolidayImport(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "districtholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Calendar was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadHolidays();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "districtholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update calendar: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//
	//	OLD, Remove 1 at a time
	//
	// onRemove() {
	// 	this.errorMessage = "";

	// 	if (this.SelectedHoliday == undefined) {
	// 		this.errorMessage = "Select a holiday to remove";
	// 		return;
	// 	}

	// 	var Msg = "";
	// 	var ChangeTo = 1;

	// 	if (this.SelectedHoliday.IsOpen == true) {
	// 		ChangeTo = 0;
	// 	}

	// 	Msg += "Are you sure you want to " + (ChangeTo == 0 ? "close" : "open") + " all schools on " + this.SelectedHoliday.CalendarDateDesc + "?";

	// 	if (this.SelectedHoliday.InFuture == false) {
	// 		Msg += " NOTE: This day already happened. Editing previous days can affect attendance and reporting stats.";
	// 	}

	// 	this.confirmationService.confirm({
	// 		key: "districtholidayconfirm",
	// 		acceptLabel: "Yes",
	// 		rejectLabel: "No",
	// 		rejectVisible: true,
	// 		message: Msg,
	// 		header: "Confirm Remove Holiday",
	// 		icon: "fa",
	// 		accept: () => {
	// 			this.onFinishRemove(ChangeTo);
	// 		},
	// 	});
	// }

	// onFinishRemove(ChangeTo: number) {
	// 	var parms: CalendarHolidayInsertRequest = {
	// 		CalendarDate: moment(this.SelectedHoliday.CalendarDate).format("MM/DD/YYYY"),
	// 		IsOpen: ChangeTo,
	// 		AllSchools: 1,
	// 		lstSchoolID: [],
	// 	};

	// 	this.Processing = true;

	// 	var result = this.districtService.CalendarHolidayInsert(parms);
	// 	result.subscribe(
	// 		(response: any) => {
	// 			this.Processing = false;

	// 			if (response.Success == true) {
	// 				//Success Dialog
	// 				this.confirmationService.confirm({
	// 					key: "districtholiday",
	// 					acceptLabel: "Ok",
	// 					rejectVisible: false,
	// 					message: "Calendar was updated successfully.",
	// 					header: "Success",
	// 					icon: "fa",
	// 					accept: () => {
	// 						this.loadHolidays();
	// 					},
	// 				});
	// 			} else {
	// 				//Fail Dialog
	// 				this.confirmationService.confirm({
	// 					key: "districtholiday",
	// 					acceptLabel: "Ok",
	// 					rejectVisible: false,
	// 					message: "Could Not update calendar: " + response.ErrorMessage,
	// 					header: "ERROR",
	// 					icon: "fa",
	// 					accept: () => {},
	// 				});
	// 			}
	// 		},
	// 		(error) => {
	// 			this.Processing = false;
	// 		}
	// 	);
	// }

	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictImportHolidayComponent, {
			header: "Import Holidays",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadHolidays();
			}
		});
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	// onRowSelect(val) {
	// 	this.SelectedHoliday = val.data;
	// }
	// onRowUnselect(val) {
	// 	this.SelectedHoliday = null;
	// }

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.HolidayLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////////
}
